import { Dialog } from "components/Dialog";
import { useTranslation } from "react-i18next";
import { useRef, useState } from "react";
import { useDateForQueryParams } from "components/DatePicker";
import { useURLTools } from "utils/URLtools";
import { DataGridRef } from "devextreme-react/data-grid";
import WaterMetersGrid from "components/Grid/grids/WaterMetersGrid";
import { TWaterMetersGridRow } from "components/Grid/grids/WaterMetersGrid/types";

type TProps = {
  isOpen?: boolean;
  onClose: () => void;
  onSelectMeter: (value: TWaterMetersGridRow) => void;
};

export type TAddFormTypes = {
  apartmentId: string;
  floorNo: number;
  unitNo: string;
  identifierId: string;
  subscriberName: string;
  nationalId: string;
  phoneNumber: string;
  mobileNumber: string;
  postalCode: string;
  email: string;
  waterMeterId: string;
  installationDT: Date;
};

export function MetersChooserModal(props: TProps) {
  const { isOpen = false, onClose, onSelectMeter } = props;

  const { t } = useTranslation();

  const { queryParams } = useURLTools();
  const GridRef = useRef<DataGridRef<any, any>>(null);

  const onWaterMeterGridRowClick = (value: TWaterMetersGridRow) => {
    onSelectMeter(value);
  };

  return (
    <Dialog
      maxWidth={false}
      dialogTitle={t("chooseMeter")}
      open={isOpen}
      onClose={onClose}
    >
      <p className={"text-gray-110 mr-3 text-sm my-1"}>
        {t("chooseMeterFromList")}
      </p>
      <div className={"w-[1080px] h-[640px] px-2"}>
        <WaterMetersGrid
          provinceId={queryParams?.provinceId}
          cityId={queryParams?.cityId}
          jurisdictionId={queryParams?.jurisdictionId}
          isLoading={false}
          ref={GridRef}
          onRowClick={onWaterMeterGridRowClick}
        />
      </div>
    </Dialog>
  );
}
